import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/ConeGeometry'

export default meshComponent('Cone', props, createGeometry)
